import * as Yup from 'yup';

export const ceusSchema = Yup.object().shape({
  state: Yup.string().required('State is required'),
  total: Yup.string().required('Field is required'),
  required: Yup.string().required('Field is required'),
  year: Yup.string().required('Year is required'),
});
